export class File {
    constructor(data) {
        var _a;
        this.id = data.id;
        this.server = data.server;
        this.path = data.path;
        this.size = data.size;
        this.name = (_a = data.name) !== null && _a !== void 0 ? _a : null;
    }
    static decode(data) {
        var _a, _b;
        return new File({
            id: data.field("id").string,
            server: data.field("server").string,
            path: data.field("path").string,
            size: data.field("size").integer,
            name: (_b = (_a = data.optionalField("name")) === null || _a === void 0 ? void 0 : _a.string) !== null && _b !== void 0 ? _b : null,
        });
    }
    encode(context) {
        return {
            id: this.id,
            server: this.server,
            path: this.path,
            size: this.size,
            name: this.name
        };
    }
    getPublicPath() {
        return this.server + "/" + this.path;
    }
}
//# sourceMappingURL=File.js.map